import { render, staticRenderFns } from "./upload-malware.vue?vue&type=template&id=2cfdf472&"
import script from "./upload-malware.vue?vue&type=script&lang=js&"
export * from "./upload-malware.vue?vue&type=script&lang=js&"
import style0 from "./upload-malware.vue?vue&type=style&index=0&id=2cfdf472&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports